import { z } from 'zod';
import type { NonEmpty } from './emptiness';

export type EmailAddress = NonEmpty<Lowercase<string>> & {
  __emailAddressBrand: 'EmailAddress';
};
export const ZodEmailAddress = z
  .string()
  .refine(
    (str) => z.string().email().safeParse(str).success,
    (actual) => ({ message: `Invalid email: "${actual}"` }),
  )
  .transform((x) => x.toLowerCase() as EmailAddress);
